import * as configcat from "configcat-js";
import { from, Observable, of, throwError } from "rxjs";

import { Person } from "@/services/DTOs/Person";

const configCatClient = configcat.createClient(`${process.env.VUE_APP_CONFIGCAT_SDK_KEY}`);

class Service {
  public isEnabled(name: string, user?: Person): Observable<boolean> {
    switch (name) {
      case "mandalorian":
        return of(true);
      default:
        return throwError(`No feature with name ${name} was found`);
    }
  }

  public activeFor(flag: string, user?: { identifier: string, email: string }): Observable<boolean> {
    return from(configCatClient.getValueAsync(flag, false, user));
  }
}

export const FeatureFlagService = new Service();
